import React from "react";
import { Default, Ring } from "react-awesome-spinners";

const Loading = () => {
  return (
    <div className="loading-design">
      <Default />
    </div>
  );
};

export default Loading;
